import React from 'react';
import logComponent from '../../common/logComponent';
import './ProgressRingIcon.css';

export default function progressRingIcon(props) {
  if (logComponent('progressRingIcon')) { console.debug('progressRingIcon rendered'); }

  return (
    <svg className={'Progress-Ring-Icon' + (props.className ? ' ' + props.className : '') } height="100%" width="100%" viewBox="0 0 102 102">
      <circle cx="51" cy="51" r="44" strokeWidth="12" stroke="#d8d8d8" fill="transparent" />
      <path className={'Progress-Ring-Icon__ring-segment' + (props.speed <= 600 && props.speed >= 0 ? '--visible' : '')} stroke="#018465" strokeWidth="12" fill="transparent" d="M 51 7, A 44 44 0 0 1 89.28 73" />            
      <path className={'Progress-Ring-Icon__ring-segment' + (props.speed <= 1200 && props.speed > 600 ? '--visible' : '')} stroke="#c60" strokeWidth="12" fill="transparent" d="M 51 7, A 44 44 0 1 1 12.72 73" />
      <circle className={'Progress-Ring-Icon__ring-segment' + (props.speed > 1200 ? '--visible' : '')} cx="51" cy="51" r="44" strokeWidth="12" stroke="#a70d0b" fill="transparent" />
    </svg>
  );
}